<mat-card-header>
  <mat-toolbar class="toolbar">
    <mat-card-title>{{ "generatePar" | translate }}</mat-card-title>
    <span class="toolbar-spacer"></span>
    <mat-icon (click)="cancel()">cancel</mat-icon>
  </mat-toolbar>
</mat-card-header>
<mat-card-content>
<mat-dialog-content>

<div class="container">
  <form [formGroup]="freeticketform" fxLayout="column">
    <div mat-dialog-content>
      <div fxLayout="row" fxLayoutGap="30px">
        <mat-form-field appearance="outline" fxFlex="50">
          <mat-label>{{'form_fields.codetype' | translate}}</mat-label>
          <mat-select [disabled]="this.data.freeticket"  formControlName="type" tabindex="1">
            <mat-option value="ticket" *ngIf="userprivileges[100].state">
              TICKET
            </mat-option>
            <mat-option value="colis" *ngIf="userprivileges[99].state">
              COLIS
            </mat-option>
          </mat-select>
          <button type="button" mat-icon-button matSuffix
            [disabled]="(loading$ | async) || !freeticketform.valid">
            <mat-icon color="primary">dashboard</mat-icon>
          </button>
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="50">
          <mat-label>{{'form_fields.tarif' | translate}}</mat-label>
          <input type="double" matInput
              placeholder="{{'form_fields.tarif' | translate}}" (keyup)="numbersonly3($event)"
              formControlName="prix" tabindex="2">
          <button type="button" mat-icon-button matSuffix
              [disabled]="(loading$ | async) || !freeticketform.valid">
              <mat-icon color="primary">money_off</mat-icon>
          </button>

      </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutGap="30px">
        <mat-form-field class="example-full-width pl-sm-8 no-errors-spacer" appearance="outline" fxFlex="100">
          <mat-label>{{'reason' | translate}}</mat-label>
          <textarea matInput placeholder="{{'form_fields.description' | translate}}" rows="1" formControlName="comment" tabindex="9"></textarea>
          <button type="button" mat-icon-button matSuffix
            [disabled]="(loading$ | async) || !freeticketform.valid">
            <mat-icon color="primary">description</mat-icon>
        </button>
        <div *ngIf="comment.invalid && (comment.dirty || comment.touched)"
                class="alert alert-danger" style="margin-left: 100px !important;">
                <div *ngIf="description.errors.required">
                    {{'errors.description_required' | translate}}
                </div>
            </div>
        </mat-form-field>
      </div>
    </div>
    <div  fxLayout="row-reverse" fxLayoutGap="10px">
      <button (click)="confirmBox(freeticketform.value)"
        mat-raised-button
        cdkFocusInitial
        color="primary" tabindex="2"
        [disabled]="freeticketform.invalid"
      >
      <span *ngIf="!(loading$ | async)">{{
        "buttons.generate" | translate
      }}</span>
      </button>
      <a (click)="cancel()" mat-raised-button>{{
        "buttons.cancel" | translate
      }}</a>
    </div>
  </form>
</div>
